import { createAction, props } from '@ngrx/store';
import { UserListResource } from '../user.model';

const PREFIX = '[Rechtspfleger] ';

export const loadRechtspflegerAction = createAction(PREFIX + 'Load Rechtspfleger');

export const loadRechtspflegerSuccessAction = createAction(
	PREFIX + 'Load Rechtspfleger Success',
	props<{
		rechtspflegerList: UserListResource;
	}>()
);
